import React, { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import { Grid, Autocomplete, TextField, InputAdornment, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Search = forwardRef(({ onSelect }, ref) => {
  const [items, setItems] = useState([]);
  const [busqueda, setBusqueda] = useState("");
  const [open, setOpen] = useState(false);

  const API_TOKEN = process.env.REACT_APP_API_TOKEN || "";

  useImperativeHandle(ref, () => ({
    clear: () => {
      setBusqueda("");
      setItems([]);
      setOpen(false);
      onSelect(null);
    },
  }));

  useEffect(() => {
    if (busqueda.length < 2) {
      setItems([]);
      return;
    }
    (async () => {
      try {
        const resp = await fetch(`/proformas/buscar-items/?q=${encodeURIComponent(busqueda)}`, {
          headers: { "X-API-TOKEN": API_TOKEN },
        });
        const { results = [] } = await resp.json();
        setItems(results);
      } catch {
        setItems([]);
      }
    })();
  }, [busqueda]);

  const optionLabel = (opt) => {
    const base = (opt.name || "").split(" (")[0];
    return `${opt.code} – ${base}`;
  };

  const handleSelect = (_, item) => {
    if (item) {
      onSelect(item);
      setBusqueda(optionLabel(item));
    } else {
      onSelect(null);
      setBusqueda("");
    }
    setOpen(false);
  };

  const clearAll = () => {
    ref.current?.clear();
  };

  return (
    <Grid item xs={12} md={6}>
      <Autocomplete
        options={items}
        filterOptions={(x) => x}
        getOptionLabel={optionLabel}
        inputValue={busqueda}
        onInputChange={(_, v, reason) => {
          if (reason === "input") {
            setBusqueda(v);
            setOpen(v.length >= 2);
          }
        }}
        open={open}
        onChange={handleSelect}
        noOptionsText="Sin resultados"
        freeSolo
        disableClearable
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Buscar producto o servicio"
            fullWidth
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            InputProps={{
              ...params.InputProps,
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={clearAll} edge="end">
                    <CloseIcon />
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        )}
      />
    </Grid>
  );
});

export default Search;
